import axiosInstance from './axiosInstance';

export interface GameTask {
  id: string;
  cover: string;
  game_id: string;
  type: number;
  target: number;
  start: string;
  end: string;
  active: boolean;
  desc: string;
}

export interface GameTaskListResponse {
  taskList: GameTask[];
}

export class GameTaskApi {
  /**
   * 获取游戏任务列表
   * @param params 查询参数
   * @returns 游戏任务数组
   */
  static async getGameTasks(params?: { limit?: number; skip?: number }): Promise<GameTask[]> {
    const response = await axiosInstance.get('/cms/v1/game-task', { params });
    return response.data.data.taskList;
  }

  /**
   * 创建游戏任务
   * @param task 游戏任务数据
   * @returns 创建的游戏任务
   */
  static async createGameTask(task: Partial<GameTask>): Promise<GameTask> {
    const response = await axiosInstance.post('/cms/v1/game-task', task);
    return response.data.data;
  }

  /**
   * 更新游戏任务
   * @param id 游戏任务ID
   * @param task 游戏任务数据
   * @returns 更新后的游戏任务
   */
  static async updateGameTask(id: string, task: Partial<GameTask>): Promise<GameTask> {
    const response = await axiosInstance.put(`/cms/v1/game-task/${id}`, task);
    return response.data.data;
  }

  /**
   * 删除游戏任务
   * @param id 游戏任务ID
   */
  static async deleteGameTask(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/game-task/${id}`);
  }

  /**
   * 排序游戏任务
   * @param ids 游戏任务ID数组，按照排序顺序
   */
  static async sortGameTasks(ids: string[]): Promise<void> {
    await axiosInstance.post('/cms/v1/sort/game-task', { sort: ids });
  }
}